export const loadState = (key) => {
  try {
    const serializedState = window.localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const saveState = (key, state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(`${key}`, serializedState);
  } catch (error) {
    console.error(`Unable to store new value for ${key} in localStorage.`);
  }
};

export const removeState = (key) => {
  try {
    localStorage.removeItem(`${key}`);
  } catch (err) {
    console.log(err);
  }
};
